export default {
  methods: {
    getBadgeClassByStatus(status) {
      switch(status) {
        case 'Active':
        case 'In Progress':
        case 'Live':
          return 'badge-soft-success';

        case 'Draft':
        case 'Incomplete':
          return 'badge-soft-info';

        case 'Archived':
        case 'Upcoming':
          return 'badge-soft-warning';

        case 'Completed':
          return 'badge-soft-secondary';
          
        case 'Cancelled':
          return 'badge-soft-danger';
      }
    },
  }
};